<template>
  <div>
    <label
      v-if="label"
      class="mb-1.5 block text-sm font-medium text-primary"
    >
      {{ label }}
    </label>
    <input
      :class="[
        classes,
        'ring-offset-white focus:outline-none focus:ring-2 focus:ring-main-primary focus:ring-offset-2 focus:border-slate-200',
        'text-sm block w-full rounded-md border border-slate-200 leading-tight text-primary font-light placeholder:text-slate-300 placeholder:text-sm shadow-sm',
        readonly ? 'bg-gray-100' : 'bg-white',
      ]"
      :placeholder="placeholder"
      :required="required"
      :readonly="readonly"
      :disabled="inputIsDisabled"
      :autofocus="autofocus"
      :type="type"
      :value="val"
      :min="type === 'number' ? minVal : null"
      :max="type === 'number' ? maxVal : null"
      @blur="$emit('blur')"
      @focus="$emit('focus', $event)"
      @focusin="$emit('focusin')"
      @focusout="$emit('focusout', $event.target.value)"
      @input="$emit('input', $event.target.value)"
    >
    <small
      v-if="errorMessage"
      class="block mt-1 mb-2 font-medium text-red-primary"
    >{{ errorMessage }}</small>
  </div>
</template>

<script>
export default {
  name: 'TextInput',

  props: {
    val: {
      type: [String, Number, Boolean, Array],
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    classes: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    minVal: {
      type: Number,
      default: 0,
    },
    maxVal: {
      type: Number,
      default: 0,
    },
  },

  emits: ['blur', 'focus', 'focusin', 'focusout', 'input'],

  data() {
    return {
      errorMessage: this.error,
      inputIsDisabled: this.disabled,
    }
  },

  watch: {
    error(newErrorMessage) {
      this.errorMessage = newErrorMessage
    },
    disabled(isDisabled) {
      this.inputIsDisabled = isDisabled
    },
  },
}
</script>
